import { Subject } from "rxjs";
import { Channel } from "../channel";
import * as moment from "moment/moment";
import { BroadcastPresetShow } from "../show";
import { ChannelBroadcastModeState } from "../../infrastructure/broadcasts/channel-broadcast-mode-checker";

// New interface for broadcast mode updates with channel information
export interface BroadcastModeUpdate {
  channelId: number | null; // null for global state
  channelName: string | null; // null for global state
  mode: EChannelBroadcastMode;
  nextShow?: BroadcastPresetShow;
  broadcastPresetUid?: string;
  isGlobalUpdate?: boolean;
  /** When true, view model has already set mode optimistically; do not overwrite from channel state */
  fromUserStartLive?: boolean;
}

export abstract class IChannelBroadcastModeChecker {
  modeUpdated: Subject<BroadcastModeUpdate>;
  nextLiveBroadcastPresetShow: BroadcastPresetShow;
  init: () => Promise<void>;
  triggerModeUpdate: (
    startTime: moment.Moment,
    endTime: moment.Moment,
  ) => Promise<void>;
  updateGlobalBroadcastMode: () => void;
  getLiveAssosiatedPresetUid: (channelId?: number) => Promise<string | undefined>;

  // New methods
  getStateForChannel: (channelId: number) => ChannelBroadcastModeState | null;
  getGlobalBroadcastMode: () => EChannelBroadcastMode;
  getNextLiveBroadcastForChannel: (
    channelId: number,
  ) => BroadcastPresetShow | undefined;
}

export enum EChannelBroadcastMode {
  PreLive,
  Live,
  Off,
}
